import type { OpenXAgentSession } from './types';

export const MOCK_SESSIONS: OpenXAgentSession[] = [
  {
    id: '1',
    agentId: 'deal-prompt',
    timestamp: '2026-01-02 12:37',
    keyword: 'eco-conscious home buyers aged 25-45',
    timeAgo: '1d ago',
    path: 'Audience',
  },
  {
    id: '2',
    agentId: 'deal-prompt',
    timestamp: '2026-01-03 09:15',
    keyword: 'luxury travel US west coast',
    timeAgo: '2d ago',
  },
  {
    id: '3',
    agentId: 'deal-prompt',
    timestamp: '2026-01-05 14:22',
    keyword: 'sustainable fashion millennials',
    timeAgo: '4d ago',
    path: 'Deal Creation',
  },
  {
    id: '4',
    agentId: 'targeting-check',
    timestamp: '2026-01-04 11:30',
    keyword: 'premium automotive buyers',
    timeAgo: '3d ago',
    path: 'Inventory',
  },
];
